<template>
  <div class="count-page">
    <el-descriptions class="margin-top" :column="3">
      <el-descriptions-item label="入库单号">{{ inBoundOrder.order_id }}</el-descriptions-item>
      <el-descriptions-item label="入库仓库">{{ inBoundOrder.warehouse }}</el-descriptions-item>
      <el-descriptions-item label="入库单类型">{{ inBoundOrder.order_type }}</el-descriptions-item>
      <el-descriptions-item label="运输单号">{{ inBoundOrder.way_bill_no }}</el-descriptions-item>
      <el-descriptions-item label="总箱数">{{ inBoundOrder.pack_qty }}</el-descriptions-item>
      <el-descriptions-item label="物品总数">{{ inBoundOrder.item_qty }}</el-descriptions-item>
      <el-descriptions-item label="责任人">{{ inBoundOrder.charge_user_id }}</el-descriptions-item>
      <el-descriptions-item label="领取时间">{{ inBoundOrder.take_time }}</el-descriptions-item>
    </el-descriptions>
    <h2 style="width: 100%;text-align: center">入库单明细</h2>
    <el-table :data="inBoundOrder.order_item_list" style="width: 100%" stripe default-expand-all>
      <el-table-column type="expand">
        <template #default="scope">
          <div style="margin: 20px" v-if="scope.row.sn_flag">
            <h2 style="width: 100%;text-align: center">序列号装箱信息</h2>
            <div v-for="(item,index) in scope.row.packing_info" :key="index">
              <div>
                <text style="font-weight: bold">装箱箱码：</text>
                {{ item.packing_sn }}
              </div>
              <div>
                <text style="font-weight: bold">箱内序列号明细：</text>
                <div v-for="(sns,idx) in item.packing_sn_list" :key="idx"
                     style="display: flex;flex-wrap: nowrap;margin-left: 100px">
                  <div v-for="sn in sns" :key="sn.item_sn" style="width: 200px;font-weight: bold"
                       :style="{color: sn.is_received ? '#008000':'#FFA500'}">
                    {{ sn.item_sn }}
                  </div>
                </div>
              </div>
            </div>
            <div v-if="scope.row.problem_list.length > 0">
              <text style="font-weight: bold;color: red">异常序列号明细：</text>
              <div v-for="(problems,idx) in scope.row.problem_list" :key="idx"
                   style="display: flex;flex-wrap: nowrap;margin-left: 100px">
                <div v-for="problem in problems" :key="problem.id" style="width: 200px;font-weight: bold;color: red">
                  {{ problem.problem_code }}
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div style="margin: 20px">
              <div>
                <text style="font-weight: bold">入库单数量：</text>
                {{ scope.row.item_qty }}
              </div>
              <div>
                <text style="font-weight: bold">实际收货数量：</text>
                {{ scope.row.actual_item_qty }}
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="item_code" label="物料代码"></el-table-column>
      <el-table-column prop="item_name" label="物料描述"></el-table-column>
      <el-table-column prop="item_name_en" label="物料描述(英文)"></el-table-column>
      <el-table-column prop="positions" label="物料库位"></el-table-column>
      <el-table-column prop="item_qty" align="center" label="箱内数量" width="80"></el-table-column>
      <el-table-column prop="sn_flag" align="center" label="是否SN管控物料" width="130"></el-table-column>
      <el-table-column prop="is_with_battery" align="center" label="是否带电" width="80"></el-table-column>
      <el-table-column prop="battery_type" align="center" label="电池类型" width="80"></el-table-column>
    </el-table>
    <div style="width: 100%;text-align: center;margin: 20px 0">
      <el-button type="success" :loading="loading.submitFinishBtn" @click="submitCheckInFinish">入库作业全部完成</el-button>
      <el-button type="success" :loading="loading.submitRollbackBtn" @click="submitRollback">撤销入库单</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "DjiInBoundOrderCheckIn",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      itemSn: '',
      inBoundOrder: {},
      loading: {
        submitFinishBtn: false,
        submitRollbackBtn: false,
      }
    }
  },
  async created() {
    await this.getInBoundOrder();
  },
  methods: {
    async submitCheckInFinish() {
      this.loading.submitFinishBtn = true;
      this.$http('inBoundService.submitCheckInFinish', {id: this.inBoundOrder.order_id}, false).then(data => {
        this.loading.submitFinishBtn = false;
        this.$message.success("提交入库成功");
        this.getInBoundOrder();
      }, errMsg => {
        this.loading.submitFinishBtn = false;
        return this.$message.error(errMsg);
      })
    },
    async submitRollback() {
      this.$confirm('撤销入库单，需要线下寄回所有物品', '警告', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'error'
      }).then(async () => {
        this.loading.submitRollbackBtn = true;
        this.$http('inBoundService.submitRollback', {id: this.inBoundOrder.order_id}, false).then(data => {
          this.loading.submitRollbackBtn = false;
          this.$message.success("提交撤销成功");
          this.getInBoundOrder();
        }, errMsg => {
          this.loading.submitRollbackBtn = false;
          return this.$message.error(errMsg);
        })
      }).catch(() => {
      })
    },
    //获取入库单明细
    async getInBoundOrder() {
      let data = await this.$http('inBoundService.getInBoundOrder', {id: this.parentData.id,});
      this.inBoundOrder = data;
    }
  }
}
</script>


<style scoped lang="less">
.count-page {
  margin: 10px;
}
</style>